export default __webpack_public_path__ + "08bdc04dd1570e46f522d7d1c32b950c.svg";